import { Button, HFlow, Icon, PagedTable, Tag, Text, Tooltip } from 'bold-ui'
import { TableBox } from 'components/table/TableBox'
import React from 'react'

import { Ellipsis } from '../../../components/Ellipsis'
import { usePagedTableProps } from '../../../components/table'
import { useAtividadeColetivaGrupoTableQuery } from '../../../graphql/hooks.generated'
import { GrupoParticipanteAtividadeColetivaQueryInput } from '../../../graphql/types.generated'
import { convertQueryDataToTableData } from '../grupos/converter-atividadeColetivaGrupos'
import {
  AtividadeColetivaGruposFilterFormModel,
  AtividadeColetivaGruposTableModel,
} from '../grupos/model-atividadeColetivaGrupos'
import { AtividadeColetivaGruposTableDropdownMenu } from './AtividadeColetivaGruposTableDropdownMenu'

interface AtividadeColetivaGruposTableProps {
  filter: GrupoParticipanteAtividadeColetivaQueryInput
  onChangeFilter: (filter: AtividadeColetivaGruposFilterFormModel) => void
}

export const AtividadeColetivaGruposTable = (props: AtividadeColetivaGruposTableProps) => {
  const { filter, onChangeFilter } = props

  const { data, loading } = useAtividadeColetivaGrupoTableQuery({
    variables: { input: filter },
    fetchPolicy: 'cache-and-network',
  })

  const queryContent = data?.gruposParticipantesAtividadeColetiva?.content
  const convertedQueryPayload = queryContent?.map((grupo) => convertQueryDataToTableData(grupo)) || []
  const tableData = data?.gruposParticipantesAtividadeColetiva && {
    content: convertedQueryPayload,
    pageInfo: data.gruposParticipantesAtividadeColetiva.pageInfo,
  }

  const tableProps = usePagedTableProps({
    loading: loading,
    result: tableData,
    onChange: onChangeFilter,
  })

  const renderActions = () => (
    <HFlow hSpacing={0} justifyContent='flex-end'>
      <Tooltip text='Visualizar'>
        <Button size='small' skin='ghost'>
          <Icon icon='zoomOutline' />
        </Button>
      </Tooltip>
      <AtividadeColetivaGruposTableDropdownMenu />
    </HFlow>
  )

  return (
    <TableBox>
      <PagedTable<AtividadeColetivaGruposTableModel>
        loading={loading}
        columns={[
          {
            name: 'nomeGrupo',
            header: 'Nome do grupo',
            render: (row) => <Text>{row.nome}</Text>,
          },
          {
            name: 'tipoGrupo',
            header: 'Tipo de grupo',
            render: (row) => <Text>{row.tipoGrupo}</Text>,
          },
          {
            name: 'numeroParticipantes',
            header: 'Nº de participantes',
            render: (row) => <Text>{row.quantidadeCidadaosParticipantes}</Text>,
          },
          {
            name: 'unidadeSaude',
            header: 'Unidade de saúde',
            render: (row) => <Text>{row.unidadeSaude}</Text>,
          },
          {
            name: 'equipesEnvolvidas',
            header: 'Equipes envolvidas',
            render: (row) => <Ellipsis maxLines={2}>{row.equipesEnvolvidas}</Ellipsis>,
            style: { maxWidth: '16rem' },
          },
          {
            name: 'isAtivo',
            render: (row) => (row.ativo ? '' : <Tag type='normal'>Inativo</Tag>),
          },
          {
            name: 'actions',
            align: 'right',
            render: renderActions,
          },
        ]}
        {...tableProps}
      />
    </TableBox>
  )
}
